import React from 'react';
import { Customer } from '../../../types/models/customer';
import styled from 'styled-components';
import { dateFormats } from '@nextinq/domain';

const ConsentWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto 1fr;
  grid-column-gap: 1em;
  div {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 1em;
  }
`;
const Label = styled.div``;

interface ConsentWrapperProps {
  customer: Customer;
}

export function Consent(props: ConsentWrapperProps) {
  const consent = props.customer.consent;
  if (!consent) {
    return null;
  }
  return (
    <ConsentWrapper>
      <div>
        <Label>privacyPolicyAgreedAt:</Label>
        {consent.privacyPolicyAgreedAt && (
          <span>
            {dateFormats.short.dateTime(consent.privacyPolicyAgreedAt)}
          </span>
        )}
      </div>
      <div>
        <Label>sendMarketingInfoAgreedAt:</Label>
        {consent.sendMarketingInfoAgreedAt && (
          <span>
            {dateFormats.short.dateTime(consent.sendMarketingInfoAgreedAt)}
          </span>
        )}
      </div>
      <div>
        <Label>termsOfServiceAgreedAt:</Label>
        {consent.termsOfServiceAgreedAt && (
          <span>
            {dateFormats.short.dateTime(consent.termsOfServiceAgreedAt)}
          </span>
        )}
      </div>
    </ConsentWrapper>
  );
}
